<template>
  <div>
    <v-row>
      <v-col>
        <v-btn
          dark
          color="white"
          outlined
          small
          @click="backToEventList"
        >
          <span>{{ $t('eventPage.backToEventList') }}</span>
        </v-btn>
      </v-col>
    </v-row>
    <EventPage />
  </div>
</template>

<script>
import EventPage from '@/views/tss/Event/EventViews/EventPage.vue';
import { useRouter } from '@core/utils';
import { mdiChevronLeft } from '@mdi/js';

export default {
  name: 'EventPageLanding',
  components: {
    EventPage,
  },
  setup() {
    const { router } = useRouter();

    // Methods

    const backToEventList = () => {
      router.push('/');
    };

    return {
      backToEventList,

      // Others
      icons: {
        mdiChevronLeft,
      },
    };
  },
};
</script>
